import verivoxGetTabs   from './verivoxGetTabs';
import chart            from './energySourceChart';

export default showTabs => {
    if ($('.show-tabs').length < 1) {
        return false;
    }

    let $showTabs = $('.show-tabs');

    $showTabs.on('click', event => {
        let $item = $(event.currentTarget);
        let $target = $(`#${$item.data('target')}`);

        if (!$target.hasClass('loaded')) {
            verivoxGetTabs($target);
        }

        $target.slideToggle();
        $item.toggleClass('is-open');

        if (!$target.hasClass('loaded')) {
            $target.addClass('loaded');
        }

        return;
    });

    $('.energy-tab').on('click', () => {
        setTimeout(() => {
            let $sources = $('[id*=chart-]:not(.initialized)');
            chart($sources);
        }, 10);
    });
};